export default "__VITE_ASSET__053a6267__"